import { render, staticRenderFns } from "./VerticalIllustrationModal.vue?vue&type=template&id=1f117a0c&"
import script from "./VerticalIllustrationModal.vue?vue&type=script&lang=js&"
export * from "./VerticalIllustrationModal.vue?vue&type=script&lang=js&"
import style0 from "./VerticalIllustrationModal.vue?vue&type=style&index=0&id=1f117a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports